import type { HttpErrorResponse } from '@angular/common/http';

import { createAction } from '@ngrx/store';

import type { Candidate } from '@core/candidate-types';

const namespace = 'GdprCandidate';
export const GdprCandidateActions = {
  extendExpiry: createAction(
    `[${namespace}] extendExpiry`,
    (payload: { payload: { candidateId: number; gdprCustomExpiresAt: string } }) => payload,
  ),
  extendExpirySuccess: createAction(
    `[${namespace}] extendExpirySuccess`,
    (payload: { payload: { candidate: Candidate; references: [] } }) => payload,
  ),
  extendExpiryFailed: createAction(
    `[${namespace}] extendExpiryFailed`,
    (payload: { payload: { error: HttpErrorResponse; candidateId: number } }) => payload,
  ),
};
